// -- [localStorage helpers for role/topic persistence]

const ROLE_KEY = 'drivibleRole'
const TOPIC_KEY = 'drivibleTopic'

export type RoleKey = 'service' | 'sales' | 'finance' | 'management'

const VALID_ROLES: RoleKey[] = ['service', 'sales', 'finance', 'management']

export function getStoredRole(): RoleKey | null {
  try {
    const v = localStorage.getItem(ROLE_KEY)
    if (v && VALID_ROLES.includes(v as RoleKey)) return v as RoleKey
  } catch {
    // -- [ignore]
  }
  return null
}

export function getStoredTopic(): string | null {
  try {
    return localStorage.getItem(TOPIC_KEY)
  } catch {
    return null
  }
}

export function setStoredRole(role: RoleKey): void {
  try {
    localStorage.setItem(ROLE_KEY, role)
  } catch {
    // -- [ignore]
  }
}

export function setStoredTopic(topic: string): void {
  try {
    localStorage.setItem(TOPIC_KEY, topic)
  } catch {
    // -- [ignore]
  }
}

export function clearStoredPreferences(): void {
  try {
    localStorage.removeItem(ROLE_KEY)
    localStorage.removeItem(TOPIC_KEY)
  } catch {
    // -- [ignore]
  }
}
